export const SET_AUTH_TOKENS = 'setAuthTokens';
export const SET_AUTH_TOKENS_FIN = 'setAuthTokensFinalizacao';
export const INITIALIZE_FROM_COOKIES = 'initFromCookies';
export const INITIALIZE_FROM_COOKIES_FIN = 'initFromCookiesFinalizacao';
